import { FC, useState } from 'react';
import { Barbell, SoccerBall } from '@phosphor-icons/react';
import TeamProgrammingTab from '../../../components/ProgrammingPage/TeamProgrammingTab/TeamProgrammingTab';
import CoachSessionWeekView from '../../../pages/CoachSessionWeekView/CoachSessionWeekView';
import styles from './ProgrammingTabs.module.scss';

type Mode = 'gym' | 'field';

/**
 * HIDE-CAMPO (2026-07-25): Programmazione Campo temporaneamente nascosta lato UI.
 * Backend e CoachSessionWeekView intatti. Per riattivare rimettere a `true`
 * questo flag — nessun'altra modifica necessaria.
 */
const FIELD_MODE_ENABLED: boolean = false;

/**
 * Sub-tab selector dentro la sezione Programmazione del Team Detail.
 * Palestra (esistente) / Campo (nuovo — spec v1.1.1 sez 1).
 */
export const ProgrammingTabs: FC<{ teamId: string }> = ({ teamId }) => {
  const [mode, setMode] = useState<Mode>('gym');

  return (
    <div className={styles.wrapper}>
      {/* HIDE-CAMPO: switcher nascosto, resta solo Palestra — riattivare via FIELD_MODE_ENABLED */}
      {FIELD_MODE_ENABLED && (
      <div className={styles.switcher}>
        <button
          type="button"
          className={`${styles.switchBtn} ${
            mode === 'gym' ? styles.switchBtnActive : ''
          }`}
          onClick={() => setMode('gym')}
        >
          <Barbell size={14} weight="fill" />
          Programmazione Palestra
        </button>
        <button
          type="button"
          className={`${styles.switchBtn} ${
            mode === 'field' ? styles.switchBtnActive : ''
          }`}
          onClick={() => setMode('field')}
        >
          <SoccerBall size={14} weight="fill" />
          Programmazione Campo
        </button>
      </div>
      )}

      <div className={styles.body}>
        {mode === 'gym' && <TeamProgrammingTab teamId={teamId} />}
        {mode === 'field' && <CoachSessionWeekView teamId={teamId} />}
      </div>
    </div>
  );
};

export default ProgrammingTabs;
